import { useState } from "react";
import LeftArrows from "../../assets/svg/LeftArrows.svg";
import RightArrows from "../../assets/svg/RightArrows.svg";

const MachineInfoCard = ({ activeMachine }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const handlePrev = () => {
    const listCount = activeMachine?.[0]?.thumbnails ? activeMachine[0].thumbnails.length : activeMachine?.length;
    if (currentIndex > 0) {
      setCurrentIndex((prevIndex) => prevIndex - 1);
    } else {
      setCurrentIndex(listCount - 1);
    }
  };

  const handleNext = () => {
    const listCount = activeMachine?.[0]?.thumbnails ? activeMachine[0].thumbnails.length : activeMachine?.length;
    if (currentIndex + 1 < listCount) {
      setCurrentIndex((prevIndex) => prevIndex + 1);
    } else {
      setCurrentIndex(0);
    }
  };

  const currentImage = activeMachine?.[0]?.thumbnails
    ? activeMachine[0].thumbnails[currentIndex]
    : activeMachine?.[currentIndex]?.img;

  return (
    <div className="bg-[#fff]">
      <div className="custom-container">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-[46px]">
          <div className="col-span-3">
            <div className="relative w-full aspect-[4/3] flex items-center justify-center">
              <div className="absolute left-0 flex items-center justify-start h-full">
                <img src={LeftArrows} alt="Previous" className="w-[35px] sm:w-[50px] md:w-[75px] cursor-pointer" onClick={handlePrev} />
              </div>
              <div className="w-full h-full px-[45px] sm:px-[75px] md:px-[100px] flex justify-center items-center">
                <img
                  src={currentImage}
                  alt="Machine"
                  className="w-full h-full object-contain mix-blend-multiply"
                />
              </div>
              <div className="absolute right-0 flex items-center justify-end h-full">
                <img src={RightArrows} alt="Next" className="w-[35px] sm:w-[50px] md:w-[75px] cursor-pointer" onClick={handleNext} />
              </div>
            </div>

            <div className="grid lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-3 grid-cols-2 lg:gap-4 gap-2 mt-8">
              {activeMachine?.[0]?.thumbnails ? (
                activeMachine[0].thumbnails.map((thumb, idx) => (
                  <div
                    key={idx}
                    onClick={() => setCurrentIndex(idx)}
                    className={`bg-white aspect-square w-full flex items-center justify-center cursor-pointer overflow-hidden border-[4px] ${currentIndex === idx ? 'border-[#5B792E]' : 'border-[#d3d3d3]'}`}
                  >
                    <img src={thumb} className="w-full h-full object-contain" alt="" />
                  </div>
                ))
              ) : (
                <>
                  <div className="bg-[#D9D9D9] md:w-auto sm:w-auto w-[100px] md:h-[225px] sm:h-[150px] h-[100px]" />
                  <div className="bg-[#D9D9D9] md:w-auto sm:w-auto w-[100px] md:h-[225px] sm:h-[150px] h-[100px]" />
                  <div className="bg-[#D9D9D9] md:w-auto sm:w-auto w-[100px] md:h-[225px] sm:h-[150px] h-[100px]" />
                  <div className="bg-[#D9D9D9] md:w-auto sm:w-auto w-[100px] md:h-[225px] sm:h-[150px] h-[100px]" />
                </>
              )}
            </div>
          </div>
          <div className="col-span-2">
            <div className="font-[Roboto] 2xl:text-[40px] xl:text-[35px] lg:text-[30px] md:text-[26px] sm:text-[22px] text-[18px] font-extrabold text-[#000]">
              {activeMachine?.[0]?.thumbnails ? activeMachine[0]?.title : activeMachine?.[currentIndex]?.title}
            </div>
            <div className="font-[Roboto] font-normal 2xl:text-[32px] xl:text-[28px] lg:text-[24px] md:text-[20px] sm:text-[18px] text-[15px] text-[#000] mt-1 sm:mt-2">
              {activeMachine?.[0]?.thumbnails ? activeMachine[0]?.subTitle : activeMachine?.[currentIndex]?.subTitle}
            </div>

            <div className="mt-[20px] sm:mt-[40px] md:mt-[46px]">
              <div className="font-[Roboto] font-bold 2xl:text-[32px] xl:text-[28px] lg:text-[24px] md:text-[22px] sm:text-[20px] text-[16px] text-[#000]">
                Key Features:
              </div>
              <ul className="list-disc ml-[20px] sm:ml-[30px] md:ml-[40px] mt-1 sm:mt-2">
                {(activeMachine?.[0]?.thumbnails ? activeMachine[0]?.features : activeMachine?.[currentIndex]?.features)?.map((feature, idx) => (
                  <li key={idx} className="font-[Roboto] font-normal 2xl:text-[28px] xl:text-[25px] lg:text-[22px] md:text-[20px] sm:text-[18px] text-[14px] text-[#000] mb-0.5 sm:mb-1">
                    {feature}
                  </li>
                ))}
              </ul>
            </div>

            <div className="lg:mt-[50px] md:mt-[40px] mt-[30px]">
              <button
                className="rounded-lg bg-[#F2F2F2] border-[#5B792E] border-[4px] font-[Roboto] 2xl:text-[30px] xl:text-[25px] lg:text-[23px] sm:text-[20px] text-[16px] text-[#5B792E]  lg:py-[22px] md:py-[18px] sm:py-[15px] py-[10px] font-bold my-[10px] w-full"
                style={{ boxShadow: "0px 4px 4px 0px #00000040" }}
              >
                GET A QUOTE
              </button>
              {/* <button
                className="rounded-lg bg-[#7ABF5B] border-[#7ABF5B] border-[4px] font-[Roboto] 2xl:text-[30px] xl:text-[25px] lg:text-[23px] sm:text-[20px] text-[16px] text-[#fff]  lg:py-[22px] md:py-[18px] sm:py-[15px] py-[10px] font-bold my-[10px] w-full lg:mt-[30px] md:mt-[20px] mt-[10px]"
                style={{ boxShadow: "0px 4px 4px 0px #00000040" }}
              >
                FIND A DEALER
              </button> */}
            </div>

            <div className="lg:mt-[59px] md:mt-[40px] mt-[20px] md:mb-[100px] mb-[0px]">
              <a href={activeMachine?.[0]?.specSheetUrl || "/assets/pdf/tuatara1000efispec.pdf"} target="_blank" rel="noopener noreferrer">
                <div className="font-[Roboto] font-bold 2xl:text-[30px] xl:text-[25px] lg:text-[23px] sm:text-[20px] text-[16px] text-[#000] cursor-pointer">{`View Spec Sheet >`}</div>
              </a>
              <div className="font-[Roboto] font-bold 2xl:text-[30px] xl:text-[25px] lg:text-[23px] sm:text-[20px] text-[16px] text-[#000] cursor-pointer mt-[27px]">{`View Operators Manual >`}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default MachineInfoCard;
